<template>
    <div class="queued-booking-table table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th>STATUS</th>
                    <th>BOOKING DATE</th>
                    <th>CRN</th>
                    <th>FULL ADRRESS</th>
                    <th>COLLECTION DATE</th>
                </tr>
            </thead>
            <tbody>
                <template v-for="item in items" v-if="item">
                    <tr role="button"
                        :style="{
                            backgroundColor: selectedQueueBooking && selectedQueueBooking.CRN == item.CRN
                                ? '#e2e2e2' : '',
                        }"
                        v-bind:class="{
                            'disabled': item.BookingStatus.toLowerCase() == 'pending' && (
                                !selectedQueueBooking || selectedQueueBooking.CRN != item.CRN
                            )
                        }"
                        v-on:click="() => selectQueueBooking(item)"
                        v-if="item" v-bind:key="item.CRN">
                        <td v-html="getStatusLabel(item.BookingStatus)"></td>
                        <td>{{ item.bookingDate }}</td>
                        <td>{{ item.CRN }}</td>
                        <td>{{ item.FullAddress }}</td>
                        <td>{{ item.displayDate }}</td>
                    </tr>
                    <tr role="button" v-if="selectedQueueBooking && selectedQueueBooking.CRN == item.CRN" class="pointer" style="background-color: #ededed;">
                        <td colspan="5">
                            <div class="row">
                                <div class="col-12">
                                    <div class="row">
                                        <div class="col-md-4 booking-reference mb-4">
                                            <span class="booking-reference__title font-weight-bold d-block mb-2">
                                                SERVICE
                                            </span>
                                            <div class="booking-reference__refno">
                                                <EllipsisParagraph :lines='4'>
                                                    <span>{{ item.ServiceName }}</span>
                                                </EllipsisParagraph>
                                            </div>
                                        </div>
                                        <div class="col-md-4 booking-reference mb-4">
                                            <span class="booking-reference__title font-weight-bold d-block mb-2">
                                                WASTE TYPE
                                            </span>
                                            <div
                                                v-for="(workOrder, wi) in item.orders"
                                                v-bind:key="wi" class="booking-reference__waste">
                                                <EllipsisParagraph v-if="item.getDisplayWasteStreamName(
                                                        workOrder.WOWasteType
                                                    ) != 'hidestream'
                                                    " :lines='4'>
                                                    <span>{{
                                                        item.getDisplayWasteStreamName(
                                                            workOrder.WOWasteType
                                                        ) + (
                                                            isShowWooStatusReasonDesc(workOrder.woStatusReasonDesc)
                                                                ? " - " + workOrder.woStatusReasonDesc
                                                                : ""
                                                        )
                                                    }}</span>
                                                </EllipsisParagraph>
                                            </div>
                                        </div>
                                        <div class="col-md-4 booking-reference mb-4">
                                            <span class="booking-reference__title font-weight-bold d-block mb-2">
                                                NO. of COLLECTION
                                            </span>
                                            <div class="booking-reference__refno">
                                                <EllipsisParagraph :lines='4'>
                                                    <span>{{ item.Entitlement }}</span>
                                                </EllipsisParagraph>
                                            </div>
                                        </div>
                                    </div>
                                    <!--Woi Items-->
                                    <div v-if="item.hasWoi" class="row">
                                        <div class="col-md-8 booking-reference mb-4">
                                            <span class="booking-reference__title font-weight-bold d-block mb-2">
                                                SELECTED OPTION
                                            </span>
                                            <div v-for="(workOrder, wi) in item.orders" v-bind:key="wi" class="booking-reference__waste">
                                                <EllipsisParagraph v-if="workOrder.hasWoi">
                                                    {{
                                                        getWoiWasteTypeName(
                                                            workOrder.WOIWasteType,
                                                            workOrder.WOISize,
                                                            workOrder.WOIUOM
                                                        ) + (
                                                            isShowWooStatusReasonDesc(workOrder.woStatusReasonDesc)
                                                                ? " - " + workOrder.woStatusReasonDesc
                                                                : ""
                                                        )
                                                    }}
                                                </EllipsisParagraph>
                                            </div>
                                        </div>
                                        <div class="col-md-4 booking-reference mb-4">
                                            <span class="booking-reference__title font-weight-bold d-block mb-2">ITEM
                                                TYPE</span>
                                            <div v-for="(workOrder, wi) in item.orders" v-bind:key="wi" class="booking-reference__waste">
                                                <EllipsisParagraph v-if="workOrder.hasWoi">
                                                    {{
                                                        workOrder.WOIType + (
                                                            isShowWooStatusReasonDesc(workOrder.woStatusReasonDesc)
                                                                ? " - " + workOrder.woStatusReasonDesc
                                                                : ""
                                                        )
                                                    }}
                                                </EllipsisParagraph>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-4 booking-reference mb-4">
                                            <span class="booking-reference__title font-weight-bold d-block mb-2">
                                                NAME
                                            </span>
                                            <div class="booking-reference__refno">
                                                <EllipsisParagraph :lines="2">{{
                                                    item.Comments
                                                }}</EllipsisParagraph>
                                            </div>
                                        </div>
                                        <div class="col-md-4 booking-reference mb-4">
                                            <span class="booking-reference__title font-weight-bold d-block mb-2">
                                                PHONE NUMBER
                                            </span>
                                            <div class="booking-reference__waste">
                                                <EllipsisParagraph :lines="2">{{
                                                    item.PhoneNumber
                                                }}</EllipsisParagraph>
                                            </div>
                                        </div>
                                        <div class="col-md-4 booking-reference mb-4">
                                            <span class="booking-reference__title font-weight-bold d-block mb-2">
                                                EMAIL
                                            </span>
                                            <div class="booking-reference__date">
                                                <EllipsisParagraph :lines="2">{{
                                                    item.EmailAddress
                                                }}</EllipsisParagraph>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-8 booking-reference mb-4">
                                            <span class="booking-reference__title font-weight-bold d-block mb-2">
                                                COMMENT
                                            </span>
                                            <div class="booking-reference__refno">
                                                <EllipsisParagraph :lines='4'>
                                                    <span>{{ item.UserComment }}</span>
                                                </EllipsisParagraph>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="d-flex align-queuedBookings-center justify-content-end">
                                                <button type="button"
                                                    class="btn btn-outline mr-3 w-auto text-nowrap"
                                                    @click="() => closedQueueBooking()"
                                                    :style="{
                                                        borderColor: MainUISettings.button_color,
                                                        border: '1px solid',
                                                        color: MainUISettings.button_color
                                                    }">
                                                    Exit booking
                                                </button>
                                                <button type="button" class="btn btn-secondary mr-3 w-auto text-nowrap" data-toggle="modal" data-target="#rejectModal">
                                                    Reject booking
                                                </button>
                                                <ColoredButton class="w-auto btn--yes text-nowrap" @click="() => approvedBooking(item)">
                                                    Approve booking
                                                </ColoredButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                </template>
                <tr v-if="items.length == 0 && Object.keys(items).length == 0">
                    <td colspan="5">No data</td>
                </tr>
            </tbody>
        </table>
        <Modal modalId="rejectModal">
            <h4 class="text-center">REJECT BOOKING</h4>
            <div class="form-group">
                <label class="d-block text-left">Reason</label>
                <textarea
                    class="form-control"
                    :class="{ 'is-invalid': !isValidReason }"
                    rows="3"
                    v-model="rejectReason"></textarea>
            </div>
            <div class="text-center">
                <ColoredButton @click="() => rejectBooking()" class="w-auto btn--yes">
                    Reject
                </ColoredButton>
            </div>
        </Modal>
        <Modal modalId="approvedSuccessModal" ref="approvedSuccessModal">
            <div class="divToCenter mb-4">
                <div
                    class="confirmed-payment d-flex justify-content-center align-queuedBookings-center mx-auto"
                    v-bind:style="successStyle"
                >
                    <div><i class="icon-check"></i></div>
                </div>
            </div>
            <h4>BOOKING APPROVED</h4>
            <p class="mb-4">A confirmation email will be sent to the resident.</p>
            <button type="button" class="btn btn-secondary w-auto" data-dismiss="modal">
                Back to Queue
            </button>
        </Modal>
        <Modal modalId="rejectSuccessModal" ref="rejectSuccessModal">
            <div class="divToCenter mb-4">
                <div
                    class="confirmed-payment d-flex justify-content-center align-queuedBookings-center mx-auto"
                    v-bind:style="successStyle"
                >
                    <div><i class="icon-check"></i></div>
                </div>
            </div>
            <h4>BOOKING REJECTED</h4>
            <p class="mb-4">An email will be sent to the resident.</p>
            <button type="button" class="btn btn-secondary w-auto" data-dismiss="modal">
                Back to Queue
            </button>
        </Modal>
        <Modal modalId="queuedBookingAlertModal" ref="queuedBookingAlertModal" >
            <p class="mb-4">The page will be refresh.</p>
            <button type="button" class="btn btn-secondary w-auto" @click="() => hideQueuedBookingAlertModal()">
                OK
            </button>
        </Modal>
    </div>
</template>
<script>
import Texts from '../../../../common/utils/Texts';
import helper from "../../../../helper";
import EllipsisParagraph from "../../../../common/components/EllipsisParagraph";
import ColoredButton from "../../../../common/components/ColoredButton";
import Modal from "./Modal";
import DateNoTz from "../../../../common/utils/DateNoTz";
import ServerDateMixin from "../../../../common/mixins/ServerDateMixin";

export default {
    mixins: [ServerDateMixin],
    components: {
        EllipsisParagraph,
        ColoredButton,
        Modal
    },
    props: {
        items: {
            type: Array | Object,
            default: () => null
        }
    },
    data() {
        return {
            successStyle: {
                border: "1px solid #78BE20",
                color: "#F7F7F7",
                height: "3rem",
                width: "3rem",
                borderRadius: "50%",
                backgroundColor: "#78BE20",
                fontSize: "1.125rem"
            },
            delayTime: null,
            rejectReason: '',
            isValidReason: true,
            isSubmitting: false
        }
    },
    computed: {
        TEXTS: () => Texts,
        HELPER: () => helper,
        bookingSetting() {
            return this.$store.getters.GET_ACTIVE_MULTIPLE_SERVICE_BOOKING_SETTING
        },
        selectedQueueBooking() {
            return this.$store.getters.GET_SELECTED_QUEUED_BOOKING
                ? this.$store.getters.GET_SELECTED_QUEUED_BOOKING
                : null;
        },
        submitted() {
            return this.$store.getters.GET_QUEUED_BOOKING_SUBMITTED
        },
        isLoading() {
            return this.submitted
                ? (this.submitted.isLoading || this.selectedQueueBooking.isLoading)
                : false
        },
        MainUISettings() {
            return this.$store.getters["GET_MAIN_UI"];
        },
    },
    mounted() {
        window.addEventListener("beforeunload", this.checkBeforeReload, false);
    },
    beforeMount() {
    },
    async beforeDestroy() {
        if(this.selectedQueueBooking && this.selectedQueueBooking.CRN)
            await this.$store.dispatch('updateQueuedBookingStatus', {
                booking: this.selectedQueueBooking,
                status: 'Submitted',
                requestDate: new DateNoTz(this.getServerDate()).asJsDate()
            });

        window.removeEventListener("beforeunload", this.checkBeforeReload);
    },
    methods: {
        getStatusLabel(status) {
            var html = '';
            switch (status.toLowerCase()) {
                case 'pending':
                case 'in review':
                    html = '<span class="badge badge-warning">' + status.toUpperCase() + '</span>';
                    break;

                case 'submitted':
                    html = '<span class="badge badge-success">' + status.toUpperCase() + '</span>';
                    break;

                case 'rejected':
                    html = '<span class="badge badge-danger">' + status.toUpperCase() + '</span>';
                    break;

                default:
                    html = '<span class="badge badge-secondary">' + status.toUpperCase() + '</span>';
                    break;
            }

            return html;
        },
        isShowWooStatusReasonDesc(desc) {
            return desc && desc != '' && !!this.bookingSetting.show_woo_status_reason_desc
        },
        getWoiWasteTypeName(WOIWasteType, WOISize, WOIUOM) {
            // Pulls the WOIWasteName from Voyager based on Type, Size, and UOM
            var allWoiWasteTypes = this.allWoiWasteTypes;
            var foundWoiWasteType = allWoiWasteTypes.find((woiWasteType) => {
                var woiObject = woiWasteType.woi_waste_type;
                return (
                    woiObject &&
                    woiObject.api_value == WOIWasteType &&
                    woiObject.api_size == WOISize &&
                    woiObject.api_uom == WOIUOM
                );
            });
            if (foundWoiWasteType && foundWoiWasteType.woi_waste_type) {
                return foundWoiWasteType.woi_waste_type.woi_waste_name;
            } else {
                return `${WOIWasteType} ${WOISize} ${WOIUOM}`;
            }
        },
        async rejectBooking() {
            if(this.isSubmitting) return;
            if(!this.rejectReason || this.rejectReason == '') {
                this.isValidReason = false;
                return;
            }

            const booking = this.selectedQueueBooking;

            if(!booking || !booking.CRN) {
                return;
            }

            this.isSubmitting = true;

            $('#pageLoadingModal').modal('show')
            await this.$store.dispatch('getServerDate', 1);
            this.$store.dispatch('updateQueuedBookingStatus', {
                booking: booking,
                status: 'Rejected',
                Comments: this.rejectReason,
                requestDate: new DateNoTz(this.getServerDate()).asJsDate()
            });
        },
        async approvedBooking(booking) {
            if(this.isSubmitting) return;
            if(!booking || !booking.CRN) {
                return;
            }
            $('#pageLoadingModal').modal('show')
            await this.$store.dispatch('getServerDate', 1);
            this.$store.dispatch('updateQueuedBookingStatus', {
                booking: booking,
                status: 'Approved',
                requestDate: new DateNoTz(this.getServerDate()).asJsDate()
            });
        },
        async selectQueueBooking(booking) {
            if(this.isSubmitting) return;
            const selectedQueueBooking = this.selectedQueueBooking;
            // If open new booking with status be pending. Prevent it
            if(
                booking.BookingStatus.toLowerCase() == 'pending' && (
                    !selectedQueueBooking || (
                        selectedQueueBooking &&
                        selectedQueueBooking.CRN != booking.CRN
                    )
                )
            )
                return;

            this.isSubmitting = true;

            // If 1 booking was opened
            $('#pageLoadingModal').modal('show')
            await this.$store.dispatch('getServerDate', 1);
            let requestDate = new DateNoTz(this.getServerDate()).asJsDate();
            if(selectedQueueBooking && selectedQueueBooking.CRN) {
                // Close opended booking
                await this.$store.dispatch('updateQueuedBookingStatus', {
                    booking: selectedQueueBooking,
                    status: 'Submitted',
                    requestDate: requestDate
                });
                // If open new booking if action is open
                if(selectedQueueBooking.CRN != booking.CRN) {
                    this.$store.dispatch('updateQueuedBookingStatus', {
                        booking: booking,
                        status: 'Pending',
                        requestDate: requestDate
                    });
                }
            } else {
                this.$store.dispatch('updateQueuedBookingStatus', {
                    booking: booking,
                    status: 'Pending',
                    requestDate: requestDate
                });
            }
        },
        hideQueuedBookingAlertModal() {
            $('#pageLoadingModal').modal('show');
            this.$emit('refresh');
            this.$refs.queuedBookingAlertModal.hide();
        },
        async checkBeforeReload(e) {
            if (this.selectedQueueBooking && this.selectedQueueBooking.CRN) {
                e = e || window.CloseEvent;
                e.preventDefault();
                e.stopPropagation();
                await this.$store.dispatch('updateQueuedBookingStatus', {
                    booking: this.selectedQueueBooking,
                    status: 'Submitted',
                    requestDate: new DateNoTz(this.getServerDate()).asJsDate()
                });

                // For IE and Firefox prior to version 4
                if (e) {
                    e.returnValue = 'Sure?';
                }

                return "Are you sure?";
            }
        },
        async closedQueueBooking() {
            if(this.selectedQueueBooking && this.selectedQueueBooking.CRN) {
                await this.$store.dispatch('getServerDate', 1);
                $('#pageLoadingModal').modal('show');
                await this.$store.dispatch('updateQueuedBookingStatus', {
                    booking: this.selectedQueueBooking,
                    status: 'Submitted',
                    requestDate: new DateNoTz(this.getServerDate()).asJsDate()
                });
            }
        }
    },
    watch: {
        async submitted(submitted) {
            if(submitted.isSubmitted) {
                $('#rejectModal').modal('hide');
                if(submitted.error) {
                    this.$refs.queuedBookingAlertModal.show(
                        submitted.message
                    )
                } else {
                    switch (submitted.submitAction) {
                        case 'Approved':
                            this.$emit('refresh');
                            this.$refs.approvedSuccessModal.show();
                            break;
                        case 'Rejected':
                            this.rejectReason = '';
                            this.isValidReason = true;
                            this.$emit('refresh');
                            this.$refs.rejectSuccessModal.show();
                            break;
                        default:
                            break;
                    }
                }
            }
            this.isSubmitting = false;
        },
        selectedQueueBooking: {
            handler: function() {
                const $this = this;
                clearTimeout($this.delayTime);
                if(
                    $this.bookingSetting.queue_booking_review_timeout > 0 &&
                    $this.selectedQueueBooking &&
                    $this.selectedQueueBooking.BookingStatus == 'Pending'
                ) {
                    $this.delayTime = setTimeout(async () => {
                        await this.$store.dispatch('getServerDate', 1);
                        // Close opened booking
                        await $this.$store.dispatch('updateQueuedBookingStatus', {
                            booking: $this.selectedQueueBooking,
                            status: 'Submitted',
                            requestDate: new DateNoTz(this.getServerDate()).asJsDate()
                        });
                        //Alert modal
                        await $this.$refs.queuedBookingAlertModal.show(
                            '<h4>REVIEW SESSION TIME OUT</h4><p>The booking is pending for more than '+ $this.bookingSetting.queue_booking_review_timeout +' mins. You may open the booking again if you wish to continue.</p>',
                            () => {}
                        );
                        // Load new list
                        $this.$emit('refresh');
                    }, parseFloat($this.bookingSetting.queue_booking_review_timeout) * 60000)
                }
            },
            deep: true
        },
        isValidReason(val) {
            if(val && val != '')
                this.isValidReason = true
        }
    }
}
</script>